module.exports = __webpack_public_path__ + "public/Icons/getStartedArrow.svg?e3382b22";